import RandingStyle1 from "../../randing/RandingStyle1";
// import { Helmet } from "react-helmet";
import RandingStyle6 from "../../randing/RandingStyle6";

function Randing114({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <RandingStyle6
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/114/01.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/114/02.jpg`}
        formFieldColor="white"
        qOptions={["1~4개", "5개 이상", "전체", "상담필요"]}
        qOptionColor="blue"
        questionType="btn"
        privacyMessage="개인정보수집에 동의하시는 분만 '신청하기' 버튼을 눌러주세요."
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/costBenefitButton2.png`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      />
    </>
  );
}

export default Randing114;
